module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAMAAAC6V+0/AAAAIVBMVEVQUFBMaXFRUVFRUVFOTk5QUFBRUVFVVVVPT09PT09RUVFmXUP5AAAACnRSTlPwAKCQK9/PG0BQ5ei0DAAAAFFJREFUeNp1kEkOgDAMA02Wbv9/MKiigIw7x1GsJMYQYBQnyiX9IHzKxIe8JdIeEkvam7Upo7KsgR4so+t4+082KWVcLpInibh+c18I4buSBSf+SQTdXQep4wAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/web/icon-hardware.png
// module id = oMgk
// module chunks = 0